import { useFormContext } from 'react-hook-form'
import { Location } from '~/shared/api'
import { AsyncAutocompleteInput } from '~/shared/ui/Form'

type Props = {
  showSkeleton: boolean | undefined
  disabled: boolean | undefined
}

export function LocationAsyncAutocompleteInput({
  showSkeleton,
  disabled,
}: Props) {
  const { watch } = useFormContext()

  const regionOption = watch('regionId')
  const regionId = regionOption?.id

  return (
    <AsyncAutocompleteInput
      label='form.location'
      name='locationId'
      placeholder='form.select location'
      skeletonShow={showSkeleton}
      readOnly={disabled}
      fetchOptions={(name) => Location.fetchOptions(name, regionId)}
      queryKey={regionId ? [regionId] : []}
    />
  )
}
